import {
  FunctionComponent,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import { useRouter } from "next/router";
import { LoadingTextHandler } from "@bluebottlecoffee/design-system/components";
import { useUser, useAuth } from "@chordcommerce/react-autonomy";
import { homePage } from "../lib/link-builders";
import { getTokenWithRefresh } from "../lib/auth/get-token-with-refresh";

type PrivatePageProps = PropsWithChildren<{
  region: string;
  lang: string;
}>;
const PrivatePage: FunctionComponent<PrivatePageProps> = ({
  children,
  region,
  lang,
}) => {
  const { getToken, isLoggedIn, isFetching } = useAuth();
  const { user, loadUser } = useUser();
  const router = useRouter();
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        await getTokenWithRefresh(getToken);

        if (!user.data?.id) {
          await loadUser();
        }

        setIsAuthChecked(true);
      } catch (error) {
        router.replace(homePage({ region, lang }));
      }
    };

    checkStatus();
  }, []);

  if (!isLoggedIn && !isFetching) {
    return null;
  }

  return (
    <LoadingTextHandler
      isLoading={isFetching || !isAuthChecked}
      loadingText="Loading..." // TODO: i18n
    >
      {isAuthChecked && children}
    </LoadingTextHandler>
  );
};

export default PrivatePage;
